import axios from "utils/axios";

/**
 * Зміна аватарки користувача
 * @param {Object} avatarData  - fileData
 * @returns 
 */
export const setAvatar = async (avatarData) => {
    try {
        const payload = typeof avatarData === 'string'
            ? { userPicture: avatarData }
            : avatarData;
        const response = await axios.post(`/profile/avatar`, payload)
        return response.data.urlAvatar;
    } catch(error) {
        console.log(error);
        return false;
    }
}

/**
 * Зміна Telegram-акаунту поточного користувача
 * @param {string} telegram
 */
export const setTelegram = async (telegram) => {
    try {
        const response = await axios.post(`/profile/telegram`, { telegram });
        return response.data.telegram;
    } catch (error) {
        console.log(error);
        return false;
    }
};